import { useMutation } from 'react-query';
import { forgotPassword } from 'src/services/api/auth';

function useForgotPassword() {
  return useMutation(({ email, dni }) => forgotPassword(email, dni));
}

export default useForgotPassword;
